import React from "react";
import { Dialog, DialogContent, DialogTrigger } from "./base/Dialog";
import Permalink from "./Permalink";

import { useToggle } from "./utils/hooks";
import { Share2 } from "lucide-react";

export default function PermalinkMenuItem() {
  const [showModal, toggleShowModal] = useToggle(false);

  return (
    <Dialog>
      <DialogTrigger className="p-2 cursor-pointer">
        <Share2 size={18}/>
      </DialogTrigger>
      <DialogContent>
        <h5>Share</h5>
        <Permalink />
      </DialogContent>
    </Dialog>
  );
}
